import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { ROEList } from "../../components/ROEList";

export const ROEListPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="ROE List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<ROEList/>}
    />
  );
};
